export default __webpack_public_path__ + "static/DVC-Logo-mobile-701d34a0061899bc6430171aca948a3f.svg";